import dayjs from 'dayjs';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import TabPanel from '@mui/lab/TabPanel';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { Remove } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react';
import InputLabel from 'components/InputLabel/index';
import { useLocation, useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import DetailPageHeader from 'components/header/DetailPageHeader';
import { utcConverter } from './CustomComponents/LeaseUtils/helper';
import GrossRent from './CustomComponents/cardSections/GrossRentNew';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import LeaseSchedule from './CustomComponents/cardSections/LeaseSchedule';
import AdvanceAmount from './CustomComponents/cardSections/AdvanceAmountNew';
import ComparisonTable from './CustomComponents/cardSections/ComparisonTable';
import { useGetSingleIdentityMutation } from 'store/features/process/processApi';
import { LeaseComparisonPage } from './CustomComponents/comparism/LeaseComparisonPage';
import { Button, Col, DatePicker, Form, Input, InputNumber, message, Row, Select } from 'antd';
import { Box, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material';
import { isSequential, isGrossRentLessThanAdvanceOnEachItem } from '../lease-record-management-v6/CustomComponents/LeaseUtils/helper';

const { Option } = Select;

const LeaseTracker = ({ screen = 'CREATE' }) => {
	const [form] = Form.useForm();

	const [leases, setLeases] = useState([]); // State to store lease data from form
	const [yoyData, setYoyData] = useState([]);
	const [tabValues, setTabValues] = useState('1'); // Object to store tab values by lease key
	const [isCompared, setCompared] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedTab, setSelectedTab] = useState('1');
	const [nextLeaseId, setNextLeaseId] = useState(1001); // Starting lease ID
	const [expandedRowKeys, setExpandedRowKeys] = useState(true);
	const [dataFullyLoaded, setDataFullyLoaded] = useState(false);

	const { profileData } = useSelector((state) => state?.profile);

	const { state } = useLocation();
	const navigate = useNavigate();
	// console.log('🚀 ~ LeaseTracker ~ leases:', leases);
	const MAX_ROWS = 7; // Maximum number of rows allowed

	const [scheduleList, setScheduleList] = useState([]);
	// console.log(scheduleList,'scheduleList12345');

	const [GetSingle, { data: singleCaseData }] = useGetSingleIdentityMutation();
	const [getLeaseData] = useSendControlDataMutation();
	const [CreateSingle, { error: createError, isLoading: isCreateLoading, isSuccess: isCreateSuccess, isError: isCreateError }] =
		useGetSingleIdentityMutation();

	// console.log('visibleRows', visibleRows);
	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);
	};
	// Toggle expanded row
	const toggleExpand = (key) => {
		setExpandedRowKeys((prev) => !prev);
	};

	// Handle tab change for a specific lease
	const handleTabChange = (leaseKey, newValue) => {
		setTabValues(newValue);
	};

	// Function to add a new lease row
	const addLeaseRow = () => {
		setCompared(true);
		const LeaseSimulatorList = form.getFieldValue('leaseSimulator') || [];
		const currentIndex = LeaseSimulatorList?.length;
		// Check if we've reached the maximum number of rows
		if (LeaseSimulatorList.length >= MAX_ROWS) {
			message.error('Maximum limit of 7 lease records reached.');
			return;
		}

		const newLeaseId = nextLeaseId + 1;
		// console.log('newLeaseId', newLeaseId);

		// Add the new lease to state
		const newLease = {
			...LeaseSimulatorList[currentIndex - 1],
			leaseId: newLeaseId,
			leaseTitle: '',
		};

		form.setFieldValue('leaseSimulator', [...LeaseSimulatorList, newLease]);
		setNextLeaseId(newLeaseId);
	};

	// Initialize with one lease on component mount
	useEffect(() => {
		const getSingleLeaseSimulation = async (id, processCode) => {
			const res = await GetSingle({
				suffixCode: '',
				_id: id,
				operation: 'get-single',
				processCode: processCode,
			}).unwrap();

			if (res.status === 'SUCCESS') {
				if (res?.activationStatus === 'W-I-P' && res?.recordStatus === 'parked' && profileData?.userId === res?.approverUserId[0]) {
					form.setFieldsValue(res.parkedData);
					handleSubmit(res.parkedData);
				} else {
					form.setFieldsValue(res.data);
					handleSubmit(res.data);
				}
				setDataFullyLoaded(true);
			} else {
				form.setFieldsValue({});
			}
		};

		if (screen === 'CREATE') {
			form.setFieldsValue({
				leaseSimulator: [
					{
						leaseId: nextLeaseId,
						grossRentList: [
							{
								from: 1,
							},
						],
						advanceAmountList: [
							{
								from: 1,
							},
						],
						advanceAmount: 0,
					},
				],
			});
		} else {
			getSingleLeaseSimulation(state._id, state.processCode);
		}
	}, []);

	const yoyDataSet = (totalData) => {
		// Make sure totalData is an array before mapping to prevent errors
		if (!Array.isArray(totalData)) {
			return [];
		}

		return totalData.map((item) => {
			// Provide a fallback empty array in case yoySummary doesn't exist
			const yoySummaryArray = item?.responseData?.yoySummary || [];

			// Now, map over the INNER array to clean each object
			const cleanedYoyData = yoySummaryArray.map((summaryItem) => {
				// This is where the magic happens: destructuring each OBJECT in the array
				const { journals: _journals, ...rest } = summaryItem;
				return rest; // Return the object with the 'journals' key removed
			});

			// Your final console.log to verify the result
			// console.log('Cleaned yoyData:', cleanedYoyData);

			return {
				leaseId: item?.responseData?.leaseId,
				yoyData: cleanedYoyData, // Use the new, cleaned array
				yoyYears: item?.responseData?.yoyYears,
			};
		});
	};

	const handleSubmit = async (formData) => {
		setIsLoading(true);

		const leaseRequests = [];

		formData.leaseSimulator.forEach((item) => {
			//Validation
			if (item?.paymentFrequency === 'Quarterly' && item?.leaseTerm % 3 !== 0) {
				message.error(
					"Total lease months must be a multiple of 3 for quarterly payments. Please correct the Lease Payment Schedule's To Month field"
				);
				return;
			}
			if (!isSequential(item?.grossRentList)) {
				message.error('Gross Rent List must be sequential');
				return;
			}
			if (item?.advanceAmounts && !isSequential(item?.advanceAmountList)) {
				message.error('Advance Amount List must be sequential');
				return;
			}
			if (item?.advanceAmounts && !isGrossRentLessThanAdvanceOnEachItem(item?.grossRents, item?.advanceAmounts)) {
				message.error('Invalid relation between Lease Payment & Advance');
				return;
			}

			const payloadData = {
				leaseId: item?.leaseId,
				advanceAmount: item?.advanceAmount,
				discountRate: item?.discountRate,
				escalation: 0,
				grossRent: 0,
				paymentFrequency: item?.paymentFrequency,
				paymentTime: item?.paymentModality,
				leaseStartDate: item?.leaseStartDate,
				startDay: `${dayjs(item?.leaseStartDate).date()}`,
				startMonth: `${dayjs(item?.leaseStartDate).month() + 1}`,
				startYear: `${dayjs(item?.leaseStartDate).year()}`,
				upfrontLeasePayment: item?.upfrontLeasePayment,
				initialDirectCost: item?.initialDirectCost,
				cashIncentiveAmount: item?.cashIncentive,
				securityDeposit: '0.00',
				advanceAmounts: item?.advanceAmounts,
				grossRents: item?.grossRents,
				changes: [],
				leaseTerm: item?.leaseTerm,
				advanceDuration: item?.advanceAmounts?.filter((i) => i !== 0)?.length,
				endOfFinancialYear: utcConverter(dayjs().month(11).date(31)),
			};

			const convertJson = JSON.stringify(payloadData);
			const convertBase64 = btoa(convertJson);

			const formattedPayload = {
				data: convertBase64,
				processCode: state?.processCode,
				scriptName: 'lease-controller-lease',
				payloadData: payloadData,
			};

			// Return both payload and metadata
			leaseRequests.push({
				formattedPayload,
				meta: {
					leaseTitle: item?.leaseTitle,
					leaseId: item?.leaseId,
					payload: payloadData,
				},
			});
		});

		try {
			// Call all APIs in parallel
			const responses = await Promise.all(leaseRequests.map(({ formattedPayload }) => getLeaseData(formattedPayload).unwrap()));
			const yoyResponseData = yoyDataSet(responses);
			setYoyData(yoyResponseData);
			// Combine each response with its corresponding metadata
			const schedules = responses.map((res, index) => ({
				leaseTitle: leaseRequests[index].meta.leaseTitle,
				leaseId: leaseRequests[index].meta.leaseId,
				payload: leaseRequests[index].meta.payload,
				data: res?.responseData?.schedules,
			}));

			// Update state
			setScheduleList(schedules);

			const comparisonData = responses.map((res, index) => res?.responseData?.glHeadAccumulatedAmountMap);
			// console.log(comparisonData);

			setCompared(false);
			setLeases(comparisonData);
			setIsLoading(false);
		} catch (err) {
			console.error('Error fetching lease data:', err);
		}
	};

	const handleSave = () => {
		const data = form.getFieldsValue();
		if (screen === 'CREATE') {
			CreateSingle({
				operation: 'add-single',
				processCode: state?.processCode,
				suffixCode: '',
				data,
			});
		} else if (screen === 'EDIT') {
			if (singleCaseData._id && singleCaseData?.processCode && singleCaseData?.version) {
				CreateSingle({
					_id: singleCaseData._id,
					operation: 'update-single',
					processCode: singleCaseData?.processCode,
					suffixCode: '',
					data,
					version: singleCaseData?.version,
				});
			} else {
				toast.error('Failed! Some this wants wrong', toastConfig);
			}
		}
	};

	useEffect(() => {
		if (!state?.processCode) {
			navigate(-1);
		}
	}, []);

	useEffect(() => {
		if (screen === 'CREATE') {
			if (isCreateSuccess) {
				toast.success('Success! Action completed ', toastConfig);
				navigate(-1);
			}
			if (isCreateError) {
				if (createError?.data?.code === '501') {
					toast.error(createError?.data?.message, toastConfig);
				} else {
					toast.error('Failed! Action not completed', toastConfig);
				}
			}
		} else if (screen === 'EDIT') {
			if (isCreateSuccess) {
				toast.success('Success! Action completed ', toastConfig);
				navigate(-1);
			}
			if (isCreateError) {
				if (createError?.data?.code === '501') {
					toast.error(createError?.data?.message, toastConfig);
				} else {
					toast.error('Failed! Action not completed', toastConfig);
				}
			}
		}
	}, [isCreateSuccess, isCreateError, screen]);

	return (
		<>
			<DetailPageHeader
				title={screen === 'CREATE' ? 'Create Lease Simulation' : screen === 'VIEW' ? 'View Lease Simulation' : 'Edit Lease Simulation'}
			/>

			<MainCard content={false} sx={{ mb: 2, mt: '12px', borderColor: '#d9d9d9' }}>
				<div style={{ padding: '20px' }}>
					<Form form={form} onFinish={handleSubmit} disabled={screen === 'VIEW'}>
						<AntdValuePreview form={form} view={true} />

						<Row gutter={[16, 0]}>
							<Col xs={24} md={4}>
								<InputLabel label="Title" head={true} />
							</Col>
							<Col xs={24} md={8}>
								<Form.Item
									name="name"
									rules={[
										{
											required: true,
											message: 'This field is required',
										},
									]}
								>
									<Input placeholder="Write Here" />
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={[16, 0]}>
							<Col xs={24} md={4}>
								<InputLabel label="Date" head={true} />
							</Col>
							<Col xs={24} md={8}>
								<Form.Item name="date" initialValue={dayjs()} getValueProps={(value) => ({ value: value ? dayjs(value) : null })}>
									<DatePicker
										style={{ width: '100%', textAlign: 'center' }}
										inputStyle={{ textAlign: 'center' }}
										format="YYYY-MM-DD"
										disabled
									/>
								</Form.Item>
							</Col>
						</Row>

						<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', pb: '8px' }}>
							{screen === 'VIEW' ? (
								<>
									<Box></Box>
									<Button
										type="primary"
										onClick={() =>
											navigate('/static/lease-simulator/edit', {
												state,
												replace: true,
											})
										}
										disabled={false}
									>
										Edit
									</Button>
								</>
							) : (
								<>
									<Button type="primary" onClick={addLeaseRow} icon={<AddIcon size={16} />}>
										Add Options
									</Button>

									<Box sx={{ display: 'flex', flexDirection: 'row', pb: '8px', gap: '8px' }}>
										<Button loading={isLoading} type="primary" onClick={() => form.submit()}>
											Compare
										</Button>

										<Button loading={isCreateLoading} type="primary" onClick={handleSave} disabled={isCompared}>
											{screen === 'CREATE' ? 'Save' : 'Update'}
										</Button>
									</Box>
								</>
							)}
						</Box>

						<TableContainer
							sx={{
								'& table, & th, & td': {
									border: '1px solid #e0e0e0',
									borderCollapse: 'collapse',
								},
								'& th, & td': {
									p: '5px',
								},
								'& td .ant-form-item': {
									marginBottom: '0px',
								},

								'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '10%' },
								'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '10%' },
								'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '10%' },
								'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '10%' },
								'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '10%' },
								'& th:nth-of-type(6), & td:nth-of-type(6)': { width: '10%' },
								'& th:nth-of-type(7), & td:nth-of-type(7)': { width: '10%' },
								'& th:nth-of-type(8), & td:nth-of-type(8)': { width: '10%' },
								'& th:nth-of-type(9), & td:nth-of-type(9)': { width: '10%' },
								'& th:nth-of-type(10), & td:nth-of-type(10)': { width: '10%' },
								// '& th:nth-of-type(10), & td:nth-of-type(1)': { width: '11.1%' },

								'& table': { width: '100%' },
							}}
						>
							<Table
								sx={{
									'& .MuiTableBody-root .MuiTableCell-root': {
										px: 0.5,
										// mx: 0,
										// py: 0.5,
										py: 0.5,
									},
									// '& > .MuiTableBody-root > .MuiTableRow-root': {
									// 	borderTop: '2px solid #187dde',
									// },
									// '& > .MuiTableBody-root > .expanded-content-row': {
									// 	borderBottom: 'none',
									// },
									// '& > .MuiTableBody-root > .MuiTableRow-root + .expanded-content-row': {
									// 	borderTop: 'none',
									// },
									tableLayout: 'fixed',
								}}
							>
								<TableHead>
									<TableRow>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Simulation ID
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Title
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Start Date
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											IBR (%)
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Payment Frequency
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Payment Modality
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Upfront Payment
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Initial Direct Cost
										</TableCell>
										{/* <TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>Security Deposit</TableCell> */}
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Cash Incentive
										</TableCell>
										<TableCell align="center" sx={{ backgroundColor: '#e7f1f9' }}>
											Action
										</TableCell>
									</TableRow>
								</TableHead>
								<Form.List name="leaseSimulator">
									{(fields, fieldsOpt) => (
										<TableBody>
											{fields.map((field, index) => (
												<React.Fragment key={index}>
													<Form.Item name={[field.name, 'escalation']} initialValue={0} noStyle />
													<Form.Item name={[field.name, 'grossRent']} initialValue={0} noStyle />
													<TableRow sx={{ fontSize: '14px', backgroundColor: '#edf7ff' }} align="center">
														<TableCell align="center">
															<Form.Item
																name={[field.name, 'leaseId']}
																//  initialValue={lease.leaseId}
															>
																<InputNumber
																	type="number"
																	style={{ width: '100%', textAlign: 'center' }}
																	// onChange={(value) => handleLeaseIdChange(index, value)}
																/>
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item
																name={[field.name, 'leaseTitle']}
																//  initialValue={lease.leaseTitle}
															>
																<Input type="string" style={{ width: '100%', textAlign: 'center' }} />
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item
																name={[field.name, 'leaseStartDate']}
																initialValue={dayjs().startOf('month')}
																getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
																// normalize={(value) => (value ? dayjs(value) : null)}
															>
																<DatePicker
																	style={{ width: '100%', textAlign: 'center' }}
																	inputStyle={{ textAlign: 'center' }}
																	format="YYYY-MM-DD"
																/>
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item
																name={[field.name, 'discountRate']}
																rules={[
																	{
																		required: true,
																		message: 'This field is required',
																	},
																]}
															>
																<Input type="number" style={{ width: '100%', textAlign: 'center' }} />
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item name={[field.name, 'paymentFrequency']} initialValue="Monthly">
																<Select style={{ width: '100%' }}>
																	<Option value="Monthly">Monthly</Option>
																	<Option value="Quarterly">Quarterly</Option>
																</Select>
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item name={[field.name, 'paymentModality']} initialValue="Start">
																<Select style={{ width: '100%' }}>
																	<Option value="Start">Advance Basis</Option>
																	<Option value="End">Accrual Basis</Option>
																</Select>
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item name={[field.name, 'upfrontLeasePayment']}>
																<Input type="number" style={{ width: '100%', textAlign: 'right' }} />
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item name={[field.name, 'initialDirectCost']}>
																<Input type="number" style={{ width: '100%', textAlign: 'right' }} />
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Form.Item name={[field.name, 'cashIncentive']}>
																<Input type="number" style={{ width: '100%', textAlign: 'right' }} />
															</Form.Item>
														</TableCell>
														<TableCell align="center">
															<Box
																sx={{
																	display: 'flex',
																	gap: '8px',
																	flexDirection: 'row',
																	justifyContent: 'center',
																	alignItems: 'center',
																}}
															>
																<Button
																	type="link"
																	onClick={() => toggleExpand(index)}
																	disabled={false}
																	icon={
																		expandedRowKeys ? <ExpandLessIcon size={16} /> : <ExpandMoreIcon size={16} />
																	}
																	style={{ marginRight: '8px' }}
																/>
																{index !== 0 && fields?.length > 1 && (
																	<Button
																		type="link"
																		onClick={() => {
																			fieldsOpt.remove(field.name);
																		}}
																		icon={<Remove size={16} />}
																		danger
																	/>
																)}
															</Box>
														</TableCell>
													</TableRow>
													{expandedRowKeys && (
														<TableRow className="expanded-content-row">
															<TableCell colSpan={10} style={{ padding: '0' }} align="center">
																<div style={{ padding: '16px' }}>
																	<TabContext value={tabValues}>
																		<Box
																			sx={{
																				borderBottom: 1,
																				borderColor: 'divider',
																			}}
																		>
																			<Tabs
																				value={tabValues}
																				onChange={(e, newValue) => handleTabChange(index, newValue)}
																				aria-label="lease tabs"
																			>
																				<Tab label="Lease Payment" value="1" sx={{ fontSize: '13px' }} />
																				<Tab
																					label="Advance & Adjustment"
																					value="2"
																					sx={{ fontSize: '13px' }}
																				/>
																			</Tabs>
																		</Box>
																		<TabPanel value="1">
																			<GrossRent screen={screen} field={field} index={index} />
																		</TabPanel>
																		<TabPanel value="2">
																			<AdvanceAmount
																				screen={screen}
																				dataFullyLoaded={dataFullyLoaded}
																				field={field}
																				index={index}
																			/>
																		</TabPanel>
																	</TabContext>
																</div>
															</TableCell>
														</TableRow>
													)}
												</React.Fragment>
											))}
										</TableBody>
									)}
								</Form.List>
							</Table>
						</TableContainer>
					</Form>
				</div>
			</MainCard>
			{scheduleList?.length > 0 && (
				<MainCard content={false} sx={{ mb: 2, mt: '12px', borderColor: '#d9d9d9' }}>
					<div style={{ padding: '20px' }}>
						<TabContext value={selectedTab}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Tabs value={selectedTab} onChange={(e, newValue) => selectTabHandler(e, newValue)} aria-label="lease tabs">
									<Tab label="Lease" value="1" sx={{ fontSize: '13px' }} />
									<Tab label="Schedules" value="2" sx={{ fontSize: '13px' }} />
								</Tabs>
							</Box>
							<TabPanel value="1" sx={{ p: 0 }}>
								<ComparisonTable leaseDataList={leases} yoyData={yoyData} />
							</TabPanel>
							<TabPanel value="2" sx={{ p: 0 }}>
								{/*{scheduleList.map((schedule, index) => (*/}
								{/*	<LeaseSchedule key={index} leaseData={schedule} screen="CREATE" />*/}
								{/*))}*/}
								<LeaseComparisonPage leaseDataList={scheduleList} />
							</TabPanel>
						</TabContext>
					</div>
				</MainCard>
			)}
		</>
	);
};

export default LeaseTracker;
